function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFractionalShares(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 41 45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(91, 91, 91)",
      fill: "none",
      strokeWidth: "4.40259px"
    },
    transform: "matrix(0.454278, 0, 0, 0.454278, -127.640312, -149.259857)",
    d: "M 363.127634427 358.987 A 44.026 44.026 0 1 1 325 336.974 L 325 381 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(91, 91, 91)"
    },
    transform: "matrix(0.454278, 0, 0, 0.454278, -175.065231, -138.997269)",
    d: "M 434 305.974 A 44.026 44.026 0 0 1 472.127634427 327.987 L 434 350 Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFractionalShares);
export default __webpack_public_path__ + "static/media/fractional-shares.26a4b313a5792e309b0a9a788cf870a2.svg";
export { ForwardRef as ReactComponent };